export default "/images/arm_econom_bank.png?3d26dd7887c8355aa82fbff0fffbb214";